/**
 * HOR-75/HOR-74: Status-Beschriftung und -Farbe der Vorgaenge.
 *
 * Lag bisher lokal in src/pages/Services/index.jsx. Die Kundendetailansicht
 * zeigt dieselben Vorgaenge und darf sie nicht in eigenen Farben einfaerben,
 * deshalb hier als gemeinsame Quelle.
 */
export const statusColors = {
  companyDeclined: 'red',
  waitingForKVA: 'blue',
  waitingForPayment: 'orange',
  customerApprovedKVA: 'green',
  offerApproved: 'green',
  approvalDeclined: 'red',
  cancelledAndShipping: 'red',
  approval: 'blue',
  offerDeclined: 'red',
  shippingClarification: 'green',
  watchReceived: 'blue',
  finished: 'green',
  kvaReceived: 'purple',
  // HOR-13: orange – admin action required (confirm return shipping), not a terminal state
  finishedAndShipping: 'orange',
  inProgress: 'purple',
  offerReceived: 'purple',
  customerDeclinedKVA: 'red',
}

export const formatStatus = status => ({
  // i18n() forwards options to i18next.t – unknown backend statuses fall back to a translated label
  title: i18n(`services.status.${status}`, { defaultValue: i18n('common.unknown') }),
  color: statusColors[status] || '#000000',
})
